import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
import { environment } from './environments/environment';
import { hmrBootstrap } from './hmr';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (environment.production) {
    enableProdMode();
}
var bootstrap = function () { return __NgCli_bootstrap_2.platformBrowser().bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory); };
var ɵ0 = bootstrap;
if (environment.hmr) {
    if (module['hot']) {
        module['hot'].accept();
        hmrBootstrap(module, bootstrap);
    }
    else {
        console.error('HMR is not enabled for webpack-dev-server!');
        console.log('Are you using the --hmr flag for ng serve?');
    }
}
else {
    bootstrap().catch(function (err) { return console.log(err); });
}
// skip dataDog SDK initialization on localhost
if (location.hostname !== 'localhost.hansel.io') {
    datadogRum.init({
        applicationId: '3cdd9e28-df7e-44e0-88d7-1a9bbb762aad',
        clientToken: 'pubf601b23d7f2059d3c8e4f8496c852843',
        site: 'datadoghq.com',
        service: 'px',
        sampleRate: 100,
        trackInteractions: true
    });
}
export { ɵ0 };
